"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
exports.default = vue_1.default.extend({
    props: ['action-id', 'label', 'cssClass', 'icon', 'mandatoryFields', 'ignoreFields'],
    mixins: [ConditionalDisplay_1.default],
    data: function () {
        var model = this.$root.$data;
        var css = this.cssClass;
        if (css && css.indexOf('btn-') === -1) {
            css = 'btn-info ' + css;
        }
        else if (!css) {
            css = 'btn-info';
        }
        css = 'd-inline-block mx-auto action-button btn ' + css;
        return {
            cssString: css,
            isVisible: !model.readOnly
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Action/Action.vue
// module id = 210
// module chunks = 0